var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPinkBoat = function SvgPinkBoat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 108,
    viewBox: "0 0 164 108",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7204 71.3759L0 50.3901L55.3792 48.6413L43.7204 71.3759Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7204 71.3759L0 50.3901L55.3792 48.6413L43.7204 71.3759Z",
    fill: "url(#pink_boat_paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.332 70.7931L106.678 48.0585L163.223 45.7267L125.332 70.7931Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.332 70.7931L106.678 48.0585L163.223 45.7267L125.332 70.7931Z",
    fill: "url(#pink_boat_paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5322 90.384L81.7583 1.19046L132.306 73.382L91.5006 96.3464L81.5322 90.384Z",
    fill: "url(#pink_boat_paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7887 0.412628L22.928 68.7634L81.7887 88.8798V0.412628Z",
    fill: "url(#pink_boat_paint3_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0289 0.979858L22.1683 69.3307L81.0289 89.447V0.979858Z",
    fill: "url(#pink_boat_paint4_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2504 98.5887L0.777222 51.3222L77.1331 62.2581L164 46.6587L146.715 94.2783L80.2119 107.825L19.2504 98.5887Z",
    fill: "url(#pink_boat_paint5_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2504 98.5887L0.777222 51.3222L77.1331 62.2581L164 46.6587L146.715 94.2783L80.2119 107.825L19.2504 98.5887Z",
    fill: "url(#pink_boat_paint6_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4732 97.8107L0 50.5442L76.3558 61.4801L163.223 45.8807L145.938 93.5003L79.4347 107.047L18.4732 97.8107Z",
    fill: "url(#pink_boat_paint7_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4732 97.8107L0 50.5442L76.3558 61.4801L163.223 45.8807L145.938 93.5003L79.4347 107.047L18.4732 97.8107Z",
    fill: "url(#pink_boat_paint8_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink_boat_paint0_linear",
    x1: 27.6896,
    y1: 48.6413,
    x2: 27.6896,
    y2: 71.3759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D789F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink_boat_paint1_linear",
    x1: 134.95,
    y1: 45.7267,
    x2: 134.95,
    y2: 70.7931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D789F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink_boat_paint2_linear",
    x1: 111.312,
    y1: -19.4109,
    x2: 96.6225,
    y2: 175.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink_boat_paint3_linear",
    x1: 69.3675,
    y1: -25.2359,
    x2: 70.5333,
    y2: 161.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557327,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink_boat_paint4_linear",
    x1: 81.2206,
    y1: 52.6816,
    x2: 5.24645,
    y2: -25.8186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink_boat_paint5_linear",
    x1: 82.3863,
    y1: 10.6716,
    x2: 82.3863,
    y2: 91.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC8387"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink_boat_paint6_linear",
    x1: 82.3863,
    y1: 25.8275,
    x2: 82.3863,
    y2: 136.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink_boat_paint7_linear",
    x1: 80.4432,
    y1: 75.8041,
    x2: 81.6091,
    y2: 150.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D789F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink_boat_paint8_linear",
    x1: -100.068,
    y1: 70.1691,
    x2: 231.031,
    y2: 69.7805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743124,
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPinkBoat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pink_boat.e481b4f3.svg";
export { ForwardRef as ReactComponent };